import {NotificationTypes} from "../enums/NotificationTypes.js";

/**
 * Creates a notification object.
 * @param {Object} params - Notification parameters.
 * @param {string|null} params.id - Notification id.
 * @param {string} params.type - The type of notification.
 * @param {string} params.title - The notification title.
 * @param {string} params.description - The notification description text.
 * @param {boolean} [params.unread=true] - Whether the notification is unread.
 * @param {boolean} [params.localized=true] - Whether the text is localized.
 * @param {string|null} [params.time=null] - Formatted time string (e.g. "2 min ago").
 * @param {string|null} [params.link=null] - Url to go.
 * @returns {{type: string, title: string, description: string, unread: boolean, localized: boolean}} The created notification object.
 */
export const createNotification = ({
    id,
    type,
    title,
    description,
    unread = true,
    localized = false,
    time = null,
    link = null
}) => ({
    id, type, title, description, unread, localized, time, link
});

export const createOnboardingNotification = () => {
    return createNotification({
        id: null,
        type: NotificationTypes.onboarding,
        title: 'onboarding_notification.title',
        description: 'onboarding_notification.description',
        unread: false,
        localized: true
    });
}
